import { FormProvider } from 'react-hook-form';
import { Form } from './Form';
import { useContext, useEffect } from 'react';
import { Stack } from '@mui/material';
import { Title } from './Title';
import { LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_ID, SUPPLIERS_STEPS } from 'Enum/suppliers';
import { useNavigate } from 'react-router-dom';
import { useDoctorsSuppliersForm } from 'Hooks/useDoctorsSuppliersForm';
import { DoctorsSuppliersContext } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { SuppliersContext } from 'Context/SuppliersContext';

export const DoctorsSearchForm = () => {
  const { DoctorsSuppliersForm } = useDoctorsSuppliersForm();
  const { setStepIndex, setSuppliersId } = useContext(SuppliersContext);
  const { setFilters } = useContext(DoctorsSuppliersContext);

  const navigate = useNavigate();

  const specialty = DoctorsSuppliersForm.watch('specialty');
  useEffect(() => {
    setSuppliersId(SUPPLIERS_ID.doctors);
    setFilters({ specialty: DoctorsSuppliersForm.getValues('specialty') });
  }, [setFilters, setSuppliersId, specialty, DoctorsSuppliersForm]);

  return (
    <FormProvider {...DoctorsSuppliersForm}>
      <LinkReturnToMain
        label={Dictionary[DICTIONARY.General].return}
        onClick={() => {
          setStepIndex(SUPPLIERS_STEPS.LOBBY);
          navigate('/suppliers');
        }}
      />
      <Stack gap={'16px'} alignItems={'center'}>
        <Title />
        <Form />
      </Stack>
    </FormProvider>
  );
};
